<template>
  <div class="diko-report-container-wrapper">
    <div class="diko-report-container">

      <!-- HEADER -->
      <header class="diko-report-header">
        <div class="diko-header-left">
          <img
            :src="appLogoImage"
            alt="logo"
            class="diko-logo"
          >
        </div>
        <div class="diko-header-center">
          <h1 class="diko-title">
            DİKO GRUP BELİRLEME TESTİ
          </h1>
          <h1 class="diko-title">
            (GBT) SONUÇ RAPORU
          </h1>
        </div>
        <div class="diko-header-right">
          <div class="diko-header-meta">
            <div class="diko-meta-item">
              <feather-icon
                icon="FileTextIcon"
                size="14"
                class="diko-meta-icon"
              />
              <div class="diko-meta-texts">
                <span class="diko-meta-value">{{ userTest._id }}</span>
                <span class="diko-meta-label">TEST NO</span>
              </div>
            </div>
            <div class="diko-meta-item">
              <feather-icon
                icon="HomeIcon"
                size="14"
                class="diko-meta-icon"
              />
              <div class="diko-meta-texts">
                <span class="diko-meta-value">DİKO UYGULAMA MERKEZİ</span>
                <span class="diko-meta-label">UYGULAMA MERKEZİ ID: {{ userData.createdBy }}</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- CLIENT INFO & EXPLANATIONS ROW -->
      <section class="diko-report-meta-row">
        <!-- Client Info Card -->
        <div class="diko-meta-card diko-client-card">
          <div class="diko-client-row">
            <feather-icon
              icon="UserIcon"
              size="16"
              class="diko-client-icon"
            />
            <div class="diko-client-info">
              <span class="diko-client-label">İSİM SOYİSİM</span>
              <span class="diko-client-val">{{ userData.name }}</span>
            </div>
          </div>
          <div class="diko-client-row">
            <feather-icon
              icon="CalendarIcon"
              size="16"
              class="diko-client-icon"
            />
            <div class="diko-client-info">
              <span class="diko-client-label">YAŞ</span>
              <span class="diko-client-val">{{ userData.age }}</span>
            </div>
          </div>
          <div class="diko-client-row">
            <!-- Custom Combined Gender SVG -->
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              stroke-width="2.5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="diko-client-icon"
            >
              <circle
                cx="10"
                cy="14"
                r="4"
              />
              <line
                x1="10"
                y1="10"
                x2="10"
                y2="3"
              />
              <line
                x1="7"
                y1="5"
                x2="13"
                y2="5"
              />
              <circle
                cx="16"
                cy="8"
                r="3"
              />
              <line
                x1="18.5"
                y1="5.5"
                x2="21"
                y2="3"
              />
              <line
                x1="21"
                y1="3"
                x2="17"
                y2="3"
              />
              <line
                x1="21"
                y1="3"
                x2="21"
                y2="7"
              />
            </svg>
            <div class="diko-client-info">
              <span class="diko-client-label">CİNSİYET</span>
              <span class="diko-client-val">{{ userData.gender === "Kız" ? "Kız" : "Erkek" }}</span>
            </div>
          </div>
          <div class="diko-client-row">
            <feather-icon
              icon="ClockIcon"
              size="16"
              class="diko-client-icon"
            />
            <div class="diko-client-info">
              <span class="diko-client-label">TARİH</span>
              <span class="diko-client-val">{{ new Date(userData.createdAt).toLocaleDateString('tr-TR') }}</span>
            </div>
          </div>
        </div>

        <!-- Explanations Card -->
        <div class="diko-meta-card diko-explanation-card">
          <span class="diko-exp-title">AÇIKLAMALAR</span>
          <ul class="diko-exp-list">
            <li>
              <div class="diko-exp-check">
                <feather-icon
                  icon="CheckIcon"
                  size="10"
                />
              </div>
              <p><strong>Raporun Amacı:</strong> Bu rapor, danışanın bilişsel performansını objektif verilerle görüntülemek ve Diko Dikkat ve Konsantrasyon Programı süresince izlenecek kişiselleştirilmiş gelişim rotasını belirlemek amacıyla hazırlanmıştır.</p>
            </li>
            <li>
              <div class="diko-exp-check">
                <feather-icon
                  icon="CheckIcon"
                  size="10"
                />
              </div>
              <p><strong>Grup Tanımlaması:</strong> Diko Grup Belirleme Testi sonuçları, bilişsel performans düzeyinize göre A, B, C, D ve E gruplarına göre sınıflandırılmaktadır.</p>
            </li>
            <li>
              <div class="diko-exp-check">
                <feather-icon
                  icon="CheckIcon"
                  size="10"
                />
              </div>
              <p><strong>Çalışma Basamağı:</strong> Bu gruplar bir başarı veya başarısızlık göstergesi değildir. Bulunduğunuz grup, mevcut bilişsel performansınıza en uygun zorluk derecesindeki egzersizlerin tanımlandığı çalışma alanınızı ifade eder. A grubu en zor ve ileri düzeydeki egzersizleri içerirken, E grubu temel becerilere odaklanan başlangıç düzeyindeki uygulamalardan oluşmaktadır.</p>
            </li>
            <li>
              <div class="diko-exp-check">
                <feather-icon
                  icon="CheckIcon"
                  size="10"
                />
              </div>
              <p><strong>Ortalama Verisi:</strong> Grafiklerdeki "Ortalama" ifadesi, danışan ile aynı yaş grubundaki diğer bireylerin test sonuçlarından elde edilen genel başarı ortalamasını temsil eder.</p>
            </li>
          </ul>
        </div>
      </section>

      <!-- PERFORMANS ÖZETİ -->
      <section class="diko-report-section">
        <div class="diko-section-header">
          <div class="diko-section-title-tab">
            GRUP ANALİZİ
          </div>
        </div>
        <div class="diko-performance-summary-cards">

          <!-- Card 1: DİKKAT -->
          <div class="diko-summary-card diko-theme-attention">
            <div class="diko-card-header">
              <div class="diko-card-icon-circle">
                <feather-icon
                  icon="EyeIcon"
                  size="14"
                />
              </div>
              <span class="diko-card-title">DİKKAT</span>
            </div>

            <!-- Custom Vertical Bar Chart -->
            <div class="diko-vertical-chart">
              <div class="diko-chart-y-axis">
                <span>A</span>
                <span>B</span>
                <span>C</span>
                <span>D</span>
                <span>E</span>
                <span>0</span>
              </div>
              <div class="diko-chart-grid-lines">
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
              </div>
              <div class="diko-chart-bars">
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar danisan-bar"
                    :style="{ height: getVerticalBarHeight(userTest.attention) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(userTest.attention) }}</span>
                  </div>
                  <span class="diko-bar-label">DANIŞAN</span>
                </div>
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar ortalama-bar"
                    :style="{ height: getVerticalBarHeight(averageScores.att) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(averageScores.att) }}</span>
                  </div>
                  <span class="diko-bar-label">ORTALAMA</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card 2: MANTIK -->
          <div class="diko-summary-card diko-theme-logic">
            <div class="diko-card-header">
              <div class="diko-card-icon-circle">
                <feather-icon
                  icon="AwardIcon"
                  size="14"
                />
              </div>
              <span class="diko-card-title">MANTIK</span>
            </div>

            <!-- Custom Vertical Bar Chart -->
            <div class="diko-vertical-chart">
              <div class="diko-chart-y-axis">
                <span>A</span>
                <span>B</span>
                <span>C</span>
                <span>D</span>
                <span>E</span>
                <span>0</span>
              </div>
              <div class="diko-chart-grid-lines">
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
              </div>
              <div class="diko-chart-bars">
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar danisan-bar"
                    :style="{ height: getVerticalBarHeight(userTest.logic) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(userTest.logic) }}</span>
                  </div>
                  <span class="diko-bar-label">DANIŞAN</span>
                </div>
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar ortalama-bar"
                    :style="{ height: getVerticalBarHeight(averageScores.log) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(averageScores.log) }}</span>
                  </div>
                  <span class="diko-bar-label">ORTALAMA</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card 3: KONSANTRASYON -->
          <div class="diko-summary-card diko-theme-concentration">
            <div class="diko-card-header">
              <div class="diko-card-icon-circle">
                <feather-icon
                  icon="TargetIcon"
                  size="14"
                />
              </div>
              <span class="diko-card-title">KONSANTRASYON</span>
            </div>

            <!-- Custom Vertical Bar Chart -->
            <div class="diko-vertical-chart">
              <div class="diko-chart-y-axis">
                <span>A</span>
                <span>B</span>
                <span>C</span>
                <span>D</span>
                <span>E</span>
                <span>0</span>
              </div>
              <div class="diko-chart-grid-lines">
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
              </div>
              <div class="diko-chart-bars">
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar danisan-bar"
                    :style="{ height: getVerticalBarHeight(userTest.concentration) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(userTest.concentration) }}</span>
                  </div>
                  <span class="diko-bar-label">DANIŞAN</span>
                </div>
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar ortalama-bar"
                    :style="{ height: getVerticalBarHeight(averageScores.con) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(averageScores.con) }}</span>
                  </div>
                  <span class="diko-bar-label">ORTALAMA</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card 4: HAFIZA -->
          <div class="diko-summary-card diko-theme-memory">
            <div class="diko-card-header">
              <div class="diko-card-icon-circle">
                <feather-icon
                  icon="CpuIcon"
                  size="14"
                />
              </div>
              <span class="diko-card-title">HAFIZA</span>
            </div>

            <!-- Custom Vertical Bar Chart -->
            <div class="diko-vertical-chart">
              <div class="diko-chart-y-axis">
                <span>A</span>
                <span>B</span>
                <span>C</span>
                <span>D</span>
                <span>E</span>
                <span>0</span>
              </div>
              <div class="diko-chart-grid-lines">
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
                <div class="diko-grid-line" />
              </div>
              <div class="diko-chart-bars">
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar danisan-bar"
                    :style="{ height: getVerticalBarHeight(userTest.memory) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(userTest.memory) }}</span>
                  </div>
                  <span class="diko-bar-label">DANIŞAN</span>
                </div>
                <div class="diko-chart-bar-col">
                  <div
                    class="diko-bar ortalama-bar"
                    :style="{ height: getVerticalBarHeight(averageScores.mem) }"
                  >
                    <span class="diko-bar-grade">{{ getGradeLetter(averageScores.mem) }}</span>
                  </div>
                  <span class="diko-bar-label">ORTALAMA</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- DETAYLI PERFORMANS KARŞILAŞTIRMASI -->
      <section class="diko-report-section">
        <div class="diko-section-header">
          <div class="diko-section-title-tab">
            İŞLEM HIZI(SÜRE) ANALİZİ
          </div>
        </div>

        <div class="diko-horizontal-comparison">
          <div class="diko-comparison-row">
            <!-- Left Category labels -->
            <div class="diko-comparison-left-col">
              <div class="diko-comp-label-item">
                <div class="diko-comp-icon-circle diko-theme-attention">
                  <feather-icon
                    icon="EyeIcon"
                    size="10"
                  />
                </div>
                <span class="diko-comp-label-text">DİKKAT</span>
              </div>
              <div class="diko-comp-label-item">
                <div class="diko-comp-icon-circle diko-theme-logic">
                  <feather-icon
                    icon="AwardIcon"
                    size="10"
                  />
                </div>
                <span class="diko-comp-label-text">MANTIK</span>
              </div>
              <div class="diko-comp-label-item">
                <div class="diko-comp-icon-circle diko-theme-concentration">
                  <feather-icon
                    icon="TargetIcon"
                    size="10"
                  />
                </div>
                <span class="diko-comp-label-text">KONSANTRASYON</span>
              </div>
              <div class="diko-comp-label-item">
                <div class="diko-comp-icon-circle diko-theme-memory">
                  <feather-icon
                    icon="CpuIcon"
                    size="10"
                  />
                </div>
                <span class="diko-comp-label-text">HAFIZA</span>
              </div>
            </div>

            <!-- Danisan Horizontal Chart -->
            <div class="diko-comparison-chart-col">
              <span class="diko-comp-header">DANIŞAN</span>
              <div class="diko-comp-bar-container">
                <div class="diko-comp-grid-lines">
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                </div>
                <div class="diko-comp-bars-wrapper">
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-attention"
                      :style="{ width: getHorizontalBarWidth(attTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ attTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-logic"
                      :style="{ width: getHorizontalBarWidth(logTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ logTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-concentration"
                      :style="{ width: getHorizontalBarWidth(conTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ conTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-memory"
                      :style="{ width: getHorizontalBarWidth(memTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ memTimeTotal.toFixed(2) }} sn</span>
                  </div>
                </div>
              </div>
              <div class="diko-comp-x-axis">
                <span>0</span>
                <span>30</span>
                <span>60</span>
                <span>90</span>
                <span>120</span>
                <span>150</span>
              </div>
            </div>

            <!-- Ortalama Horizontal Chart -->
            <div class="diko-comparison-chart-col">
              <span class="diko-comp-header">ORTALAMA</span>
              <div class="diko-comp-bar-container">
                <div class="diko-comp-grid-lines">
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                  <div class="diko-comp-grid-line" />
                </div>
                <div class="diko-comp-bars-wrapper">
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-attention ortalama-shade"
                      :style="{ width: getHorizontalBarWidth(aAttTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ aAttTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-logic ortalama-shade"
                      :style="{ width: getHorizontalBarWidth(aLogTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ aLogTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-concentration ortalama-shade"
                      :style="{ width: getHorizontalBarWidth(aConTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ aConTimeTotal.toFixed(2) }} sn</span>
                  </div>
                  <div class="diko-comp-bar-row">
                    <div
                      class="diko-horizontal-bar diko-theme-memory ortalama-shade"
                      :style="{ width: getHorizontalBarWidth(aMemTimeTotal) }"
                    />
                    <span class="diko-comp-bar-value">{{ aMemTimeTotal.toFixed(2) }} sn</span>
                  </div>
                </div>
              </div>
              <div class="diko-comp-x-axis">
                <span>0</span>
                <span>30</span>
                <span>60</span>
                <span>90</span>
                <span>120</span>
                <span>150</span>
              </div>
            </div>

          </div>
        </div>

      </section>

      <!-- CEVAP ANALİZİ VE ORTALAMA KARŞILAŞTIRMASI -->
      <section class="diko-report-section">
        <div class="diko-section-header header-purple">
          <div class="diko-section-title-tab">
            CEVAP ANALİZİ
          </div>
        </div>

        <!-- 3 Columns (Attention, Concentration, Logic) -->
        <div class="diko-qa-cols">
          <!-- Attention Column -->
          <div class="diko-qa-col">
            <div class="diko-qa-table-header diko-theme-attention">
              <div class="diko-qa-header-title">
                <div class="diko-qa-header-circle">
                  <feather-icon
                    icon="EyeIcon"
                    size="14"
                  />
                </div>
                <span>DİKKAT</span>
              </div>
            </div>
            <table class="diko-qa-table">
              <thead>
                <tr>
                  <th>SORU</th>
                  <th>DANIŞAN</th>
                  <th>ORTALAMA</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in reportData.attention"
                  :key="'att-'+index"
                >
                  <td class="diko-qa-qname">
                    {{ index + 1 }}. Soru
                  </td>
                  <td>
                    <div
                      class="diko-qa-ans"
                      :class="item.correct ? 'correct' : item.empty ? 'empty' : 'incorrect'"
                    >
                      <feather-icon
                        :icon="item.correct ? 'CheckIcon' : item.empty ? 'MinusIcon' : 'XIcon'"
                        size="10"
                      />
                      <span>{{ item.correct ? 'Doğru' : item.empty ? 'Boş' : 'Yanlış' }}</span>
                    </div>
                  </td>
                  <td class="diko-qa-avg">
                    %{{ formatPercent(item.avg) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Logic Column -->
          <div class="diko-qa-col">
            <div class="diko-qa-table-header diko-theme-logic">
              <div class="diko-qa-header-title">
                <div class="diko-qa-header-circle">
                  <feather-icon
                    icon="AwardIcon"
                    size="14"
                  />
                </div>
                <span>MANTIK</span>
              </div>
            </div>
            <table class="diko-qa-table">
              <thead>
                <tr>
                  <th>SORU</th>
                  <th>DANIŞAN</th>
                  <th>ORTALAMA</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in reportData.logic"
                  :key="'log-'+index"
                >
                  <td class="diko-qa-qname">
                    {{ index + 1 }}. Soru
                  </td>
                  <td>
                    <div
                      class="diko-qa-ans"
                      :class="item.correct ? 'correct' : item.empty ? 'empty' : 'incorrect'"
                    >
                      <feather-icon
                        :icon="item.correct ? 'CheckIcon' : item.empty ? 'MinusIcon' : 'XIcon'"
                        size="10"
                      />
                      <span>{{ item.correct ? 'Doğru' : item.empty ? 'Boş' : 'Yanlış' }}</span>
                    </div>
                  </td>
                  <td class="diko-qa-avg">
                    %{{ formatPercent(item.avg) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Concentration Column -->
          <div class="diko-qa-col">
            <div class="diko-qa-table-header diko-theme-concentration">
              <div class="diko-qa-header-title">
                <div class="diko-qa-header-circle">
                  <feather-icon
                    icon="TargetIcon"
                    size="14"
                  />
                </div>
                <span>KONSANTRASYON</span>
              </div>
            </div>
            <table class="diko-qa-table">
              <thead>
                <tr>
                  <th>SORU</th>
                  <th>DANIŞAN</th>
                  <th>ORTALAMA</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in reportData.concentration"
                  :key="'con-'+index"
                >
                  <td class="diko-qa-qname">
                    {{ index + 1 }}. Soru
                  </td>
                  <td>
                    <div
                      class="diko-qa-ans"
                      :class="item.correct ? 'correct' : item.empty ? 'empty' : 'incorrect'"
                    >
                      <feather-icon
                        :icon="item.correct ? 'CheckIcon' : item.empty ? 'MinusIcon' : 'XIcon'"
                        size="10"
                      />
                      <span>{{ item.correct ? 'Doğru' : item.empty ? 'Boş' : 'Yanlış' }}</span>
                    </div>
                  </td>
                  <td class="diko-qa-avg">
                    %{{ formatPercent(item.avg) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- HAFIZA section below -->
        <div class="diko-memory-section">
          <div class="diko-memory-header">
            <div class="diko-memory-title-container">
              <div class="diko-memory-icon-circle diko-theme-memory">
                <feather-icon
                  icon="CpuIcon"
                  size="14"
                />
              </div>
              <span class="diko-memory-title">HAFIZA</span>
            </div>
          </div>

          <div class="diko-memory-blocks">
            <div
              v-for="(page, pIndex) in reportData.memory"
              :key="'mem-'+pIndex"
              class="diko-memory-block"
            >
              <span class="diko-mem-block-title">BÖLÜM {{ pIndex + 1 }}</span>
              <div class="diko-mem-items">
                <div
                  v-for="(item, iIndex) in page.answers"
                  :key="'m-'+pIndex+'-'+iIndex"
                  class="diko-mem-item"
                >
                  <div
                    class="diko-mem-circle"
                    :class="item.correct ? 'correct' : item.empty ? 'empty' : 'incorrect'"
                  >
                    <span :class="{ 'diko-strike': !item.correct && !item.empty }">{{ iIndex + 1 }}</span>
                    <span
                      class="diko-mem-badge"
                      :class="item.correct ? 'correct' : item.empty ? 'empty' : 'incorrect'"
                    >
                      {{ item.correct ? '✓' : item.empty ? '–' : '✗' }}
                    </span>
                  </div>
                  <span class="diko-mem-avg">%{{ formatPercent(item.avg) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      <!-- FOOTER -->
      <footer class="diko-report-footer">
        <div class="diko-footer-left">
          <feather-icon
            icon="InfoIcon"
            size="12"
            class="diko-footer-info-icon"
          />
          <span>Bu rapor Diko Grup Belirleme Testi sonuçlarının değerlendirilmesi amacıyla hazırlanmıştır.</span>
        </div>
        <div class="diko-footer-right">
          <span>www.dikoturkiye.com</span>
        </div>
      </footer>

    </div>
  </div>
</template>

<script>
import axios from '@axios'
import appLogoImage from '@/assets/images/logo/dikologo.svg'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    FeatherIcon,
  },
  data() {
    return {
      userTest: {},
      userData: {},
      appLogoImage,
      attTimeTotal: 0,
      conTimeTotal: 0,
      memTimeTotal: 0,
      logTimeTotal: 0,
      aAttTimeTotal: 0,
      aConTimeTotal: 0,
      aMemTimeTotal: 0,
      aLogTimeTotal: 0,
      averageScores: {
        att: 0,
        con: 0,
        mem: 0,
        log: 0,
      },
      reportData: {
        attention: [],
        concentration: [],
        logic: [],
        memory: [],
      },
    }
  },
  created() {
    // Styling adjustments for preview/print
    const body = document.getElementsByTagName('body')[0]
    body.classList.remove('dark-layout')
    body.style.background = '#f1f5f9' // light gray page background in app preview
    const app = document.getElementById('app')
    if (app) app.classList.remove('h-100')

    // Fetch data from API
    axios.put(`/test/result/${this.$route.params.testid}`).then(({ data }) => {
      this.userTest = data.test
      this.userData = data.test.solvedBy

      console.log(data)

      // Process report data
      if (data.test && data.test.grading && data.pAvgs) {
        const { grading } = data.test
        const { pAvgs } = data
        let pAvgIndex = 0

        // Attention (0-4)
        this.reportData.attention = grading.slice(0, 5).map(g => {
          const avg = pAvgs[pAvgIndex]
          pAvgIndex += 1
          return {
            correct: g.right[0],
            empty: !g.right[0] && Array.isArray(g.time) && g.time[0] >= 30000,
            avg,
          }
        })

        // Logic (5-9)
        this.reportData.logic = grading.slice(5, 10).map(g => {
          const avg = pAvgs[pAvgIndex]
          pAvgIndex += 1
          return {
            correct: g.right[0],
            empty: !g.right[0] && Array.isArray(g.time) && g.time[0] >= 30000,
            avg,
          }
        })

        // Concentration (10-14)
        this.reportData.concentration = grading.slice(10, 15).map(g => {
          const avg = pAvgs[pAvgIndex]
          pAvgIndex += 1
          return {
            correct: g.right[0],
            empty: !g.right[0] && Array.isArray(g.time) && g.time[0] >= 30000,
            avg,
          }
        })

        // Memory (15-19)
        this.reportData.memory = grading.slice(15, 20).map((g, i) => {
          const answers = g.right.map((r, ri) => {
            const avg = pAvgs[pAvgIndex]
            pAvgIndex += 1
            return {
              correct: r,
              empty: !r && Array.isArray(g.time) && g.time[ri] >= 30000,
              avg,
            }
          })
          return {
            pageIndex: i + 1,
            answers,
          }
        })
      }

      // Calculate the NUMERICAL average scores from the 'spread' data
      this.averageScores = this.calculateAverageScores(data.spread)

      // Calculate total times for each category
      this.attTimeTotal = Array.isArray(data.tATL) && data.tATL.length > 0 ? data.tATL[data.tATL.length - 1].time : 0
      this.conTimeTotal = Array.isArray(data.tCTL) && data.tCTL.length > 0 ? data.tCTL[data.tCTL.length - 1].time : 0
      this.memTimeTotal = Array.isArray(data.tMTL) && data.tMTL.length > 0 ? data.tMTL[data.tMTL.length - 1].time : 0
      this.logTimeTotal = Array.isArray(data.tLTL) && data.tLTL.length > 0 ? data.tLTL[data.tLTL.length - 1].time : 0

      // Assuming 'data' contains the 'tAvgs' array
      const tAvgs = data.tAvgs.map(Number) // Ensure numbers are parsed

      // Attention: Elements from index 0 to 4 (1st to 5th)
      this.aAttTimeTotal = tAvgs.slice(0, 5).reduce((sum, v) => sum + v, 0)

      // Logic: Elements from index 5 to 9 (6th to 10th)
      this.aLogTimeTotal = tAvgs.slice(5, 10).reduce((sum, v) => sum + v, 0)

      // Concentration: Elements from index 10 to 14 (11th to 15th)
      this.aConTimeTotal = tAvgs.slice(10, 15).reduce((sum, v) => sum + v, 0)

      // Memory: Elements from index 15 to the end (16th onwards)
      this.aMemTimeTotal = tAvgs[17] + tAvgs[23] + tAvgs[31] + tAvgs[41] + tAvgs[53]
    })
  },
  methods: {
    calculateAverageScores(spreadData) {
      const results = {}
      const gradeScores = [1, 2, 3, 4, 5] // Scores for E, D, C, B, A

      Object.keys(spreadData).forEach(categoryKey => {
        if (categoryKey === 'total') return

        const categoryData = spreadData[categoryKey]
        const counts = categoryData.slice(0, 5)
        const totalPeople = categoryData[5]

        if (!totalPeople || totalPeople === 0) {
          results[categoryKey] = 0 // Return 0 if no data
          return
        }

        const weightedSum = counts.reduce((sum, count, index) => sum + count * gradeScores[index], 0)

        // Return the raw numerical average
        results[categoryKey] = weightedSum / totalPeople
      })
      return results
    },
    getGradeLetter(score) {
      if (!score) return 'E'
      const val = Math.round(score)
      if (val >= 1 && val <= 5) {
        return String.fromCharCode(70 - val) // 5->A, 4->B, 3->C, 2->D, 1->E
      }
      return 'E'
    },

    getVerticalBarHeight(score) {
      if (!score) return '0%'
      const val = Math.round(Number(score))
      const pct = (val / 5) * 100
      return `${pct}%`
    },
    getHorizontalBarWidth(time) {
      // Scale so that 150 seconds = 100% width
      const pct = Math.min((time / 150) * 100, 100)
      return `${pct}%`
    },
    formatPercent(val) {
      if (val === undefined || val === null) return '0.00'
      const num = Number(val)
      return Number.isNaN(num) ? val : num.toFixed(2)
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');

/* Main Wrapper in Application View */
.diko-report-container-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f5f9;
}

/* Portrait A4 Single Page Layout */
.diko-report-container {
  width: 210mm;
  height: 297mm;
  padding: 10mm 12mm;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #0f172a;
  font-family: 'Montserrat', 'Inter', -apple-system, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow-y: auto;
  position: relative;
}

/* 1. HEADER SECTION */
.diko-report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 22mm;
  border-bottom: 2px solid #0f172a;
  padding-bottom: 2mm;
}

/* Three fixed columns: logo 20%, title 40%, meta 40%. The title is centred
   within its own column, which keeps it clear of the wide meta text. */
.diko-header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 20%;
}

.diko-logo {
  height: 13mm;
  object-fit: contain;
}

.diko-logo-sub {
  font-size: 8px;
  font-weight: 800;
  color: #334155;
  margin-top: 1mm;
  white-space: nowrap;
}

.diko-header-center {
  flex: 0 0 40%;
  text-align: center;
}

.diko-title {
  font-size: 16px;
  font-weight: 800;
  color: #0284c7;
  margin: 0;
  letter-spacing: 0.5px;
}

.diko-subtitle {
  font-size: 13px;
  font-weight: 700;
  color: #0284c7;
  margin: 2px 0 0 0;
  letter-spacing: 1px;
}

.diko-header-right {
  flex: 0 0 40%;
  display: flex;
  justify-content: flex-end;
}

.diko-header-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.diko-meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.diko-meta-icon {
  color: #0f172a;
  flex-shrink: 0;
}

.diko-meta-texts {
  display: flex;
  flex-direction: column;
}

.diko-meta-value {
  font-size: 10px;
  font-weight: 800;
  color: #000000;
  line-height: 1.1;
  word-break: break-all;
}

.diko-meta-label {
  font-size: 8px;
  font-weight: 800;
  color: #334155;
  letter-spacing: 0.5px;
  line-height: 1;
  margin-top: 1px;
}

/* 2. CLIENT INFO & EXPLANATIONS ROW */
.diko-report-meta-row {
  display: flex;
  justify-content: space-between;
  height: 42mm;
  margin-top: 2mm;
}

.diko-meta-card {
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: #f8fafc;
}

.diko-client-card {
  width: 38%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.diko-client-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.diko-client-icon {
  color: #0f172a;
  flex-shrink: 0;
}

.diko-client-info {
  display: flex;
  flex-direction: column;
}

.diko-client-label {
  font-size: 8px;
  font-weight: 800;
  color: #334155;
  letter-spacing: 0.5px;
  line-height: 1;
}

.diko-client-val {
  font-size: 11px;
  font-weight: 800;
  color: #000000;
  margin-top: 2px;
}

.diko-explanation-card {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 10px;
}

.diko-exp-title {
  font-size: 10px;
  font-weight: 800;
  color: #000000;
  border-bottom: 2px solid #475569;
  padding-bottom: 2px;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.diko-exp-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  justify-content: flex-start;
}

.diko-exp-list li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.diko-exp-check {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f5f3ff;
  border: 1.2px solid #7c3aed;
  color: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.diko-exp-list p {
  font-size: 8px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.18;
}

/* 3. REPORT SECTIONS MAIN STRUCTURE */
.diko-report-section {
  display: flex;
  flex-direction: column;
  margin-top: 3.5mm;
}

.diko-section-header {
  border-bottom: 2px solid #1e293b;
  margin-bottom: 2mm;
}

.diko-section-header.header-purple {
  border-bottom: 2px solid #5b21b6;
}

.diko-section-title-tab {
  background-color: #1e293b;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  padding: 4px 12px;
  width: fit-content;
  border-top-left-radius: 4px;
  border-top-right-radius: 12px;
  letter-spacing: 0.5px;
}

.header-purple .diko-section-title-tab {
  background-color: #5b21b6;
}

/* 4. PERFORMANCE SUMMARY SECTION */
.diko-performance-summary-cards {
  display: flex;
  justify-content: space-between;
  height: 38mm;
}

.diko-summary-card {
  width: 24%;
  border-radius: 8px;
  padding: 8px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
}

.diko-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
}

.diko-card-icon-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.diko-card-title {
  font-size: 11px;
  font-weight: 800;
}

/* Custom Vertical Bar Chart */
.diko-vertical-chart {
  position: relative;
  height: 105px;
  display: flex;
  margin: 6px 0;
}

.diko-chart-y-axis {
  width: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 7.5px;
  color: #475569;
  text-align: right;
  padding-right: 4px;
  font-weight: 800;
}

.diko-chart-grid-lines {
  position: absolute;
  left: 16px;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
  z-index: 1;
}

.diko-grid-line {
  border-top: 1px dashed #cbd5e1;
  height: 0;
  width: 100%;
}

.diko-chart-bars {
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding-left: 4px;
  height: 100%;
}

.diko-chart-bar-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 45%;
}

.diko-bar-value {
  font-size: 9px;
  font-weight: 800;
  color: #000000;
  margin-bottom: 2px;
}

.diko-bar {
  width: 24px;
  border-radius: 3px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding-bottom: 2px;
  transition: height 0.5s ease;
}

.diko-bar-grade {
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  color: #ffffff;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);
}

.diko-bar-label {
  font-size: 7px;
  font-weight: 800;
  color: #475569;
  margin-top: 4px;
  letter-spacing: 0.2px;
}

.diko-card-feedback {
  font-size: 9px;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
  padding: 5px 8px;
  border-radius: 4px;
  text-align: center;
  color: #000000 !important; /* Ensure dark color for print */
}

/* Card Theme specific coloring rules */
.diko-summary-card.diko-theme-attention {
  border: 2px solid #7c3aed;
}
.diko-summary-card.diko-theme-attention .diko-card-header {
  border-bottom: 2px solid #7c3aed;
}
.diko-summary-card.diko-theme-attention .diko-card-icon-circle {
  background-color: #f5f3ff;
  color: #7c3aed;
}
.diko-summary-card.diko-theme-attention .danisan-bar {
  background-color: #7c3aed;
}
.diko-summary-card.diko-theme-attention .ortalama-bar {
  background-color: #b085f5; /* Darker than before for print visibility */
}
.diko-summary-card.diko-theme-attention .diko-card-feedback {
  background-color: #f5f3ff;
  border: 1px solid #ddd6fe;
}

.diko-summary-card.diko-theme-concentration {
  border: 2px solid #0d9488;
}
.diko-summary-card.diko-theme-concentration .diko-card-header {
  border-bottom: 2px solid #0d9488;
}
.diko-summary-card.diko-theme-concentration .diko-card-icon-circle {
  background-color: #f0fdfa;
  color: #0d9488;
}
.diko-summary-card.diko-theme-concentration .danisan-bar {
  background-color: #0d9488;
}
.diko-summary-card.diko-theme-concentration .ortalama-bar {
  background-color: #4db6ac;
}
.diko-summary-card.diko-theme-concentration .diko-card-feedback {
  background-color: #f0fdfa;
  border: 1px solid #ccfbf1;
}

.diko-summary-card.diko-theme-memory {
  border: 2px solid #ea580c;
}
.diko-summary-card.diko-theme-memory .diko-card-header {
  border-bottom: 2px solid #ea580c;
}
.diko-summary-card.diko-theme-memory .diko-card-icon-circle {
  background-color: #fff7ed;
  color: #ea580c;
}
.diko-summary-card.diko-theme-memory .danisan-bar {
  background-color: #ea580c;
}
.diko-summary-card.diko-theme-memory .ortalama-bar {
  background-color: #ffb74d;
}
.diko-summary-card.diko-theme-memory .diko-card-feedback {
  background-color: #fff7ed;
  border: 1px solid #ffedd5;
}

.diko-summary-card.diko-theme-logic {
  border: 2px solid #2563eb;
}
.diko-summary-card.diko-theme-logic .diko-card-header {
  border-bottom: 2px solid #2563eb;
}
.diko-summary-card.diko-theme-logic .diko-card-icon-circle {
  background-color: #eff6ff;
  color: #2563eb;
}
.diko-summary-card.diko-theme-logic .danisan-bar {
  background-color: #2563eb;
}
.diko-summary-card.diko-theme-logic .ortalama-bar {
  background-color: #64b5f6;
}
.diko-summary-card.diko-theme-logic .diko-card-feedback {
  background-color: #eff6ff;
  border: 1px solid #dbeafe;
}

/* 5. DETAYLI PERFORMANS KARŞILAŞTIRMASI */
.diko-horizontal-comparison {
  height: 38mm;
  display: flex;
}

.diko-comparison-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.diko-comparison-left-col {
  width: 115px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 12px 0 8px 0;
}

.diko-comp-label-item {
  display: flex;
  align-items: center;
  height: 18px;
  gap: 5px;
}

.diko-comp-icon-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.diko-comp-icon-circle.diko-theme-attention {
  background-color: #f5f3ff;
  color: #7c3aed;
  border: 1px solid #7c3aed;
}
.diko-comp-icon-circle.diko-theme-concentration {
  background-color: #f0fdfa;
  color: #0d9488;
  border: 1px solid #0d9488;
}
.diko-comp-icon-circle.diko-theme-memory {
  background-color: #fff7ed;
  color: #ea580c;
  border: 1px solid #ea580c;
}
.diko-comp-icon-circle.diko-theme-logic {
  background-color: #eff6ff;
  color: #2563eb;
  border: 1px solid #2563eb;
}

.diko-comp-label-text {
  font-size: 10px;
  font-weight: 800;
  color: #000000;
}

.diko-comparison-chart-col {
  flex: 1;
  margin: 0 8px;
  display: flex;
  flex-direction: column;
}

.diko-comp-header {
  font-size: 9.5px;
  font-weight: 800;
  text-align: center;
  color: #000000;
  margin-bottom: 2px;
}

.diko-comp-bar-container {
  position: relative;
  flex: 1;
  border-bottom: 2px solid #475569;
}

.diko-comp-grid-lines {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}

.diko-comp-grid-line {
  border-left: 1.5px dashed #cbd5e1;
  height: 100%;
}

.diko-comp-bars-wrapper {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 2px 0;
}

.diko-comp-bar-row {
  display: flex;
  align-items: center;
  height: 14px;
}

.diko-horizontal-bar {
  height: 10px;
  border-radius: 2px;
  transition: width 0.5s ease;
}

.diko-horizontal-bar.diko-theme-attention {
  background-color: #7c3aed;
}
.diko-horizontal-bar.diko-theme-attention.ortalama-shade {
  background-color: #b085f5;
}
.diko-horizontal-bar.diko-theme-concentration {
  background-color: #0d9488;
}
.diko-horizontal-bar.diko-theme-concentration.ortalama-shade {
  background-color: #4db6ac;
}
.diko-horizontal-bar.diko-theme-memory {
  background-color: #ea580c;
}
.diko-horizontal-bar.diko-theme-memory.ortalama-shade {
  background-color: #ffb74d;
}
.diko-horizontal-bar.diko-theme-logic {
  background-color: #2563eb;
}
.diko-horizontal-bar.diko-theme-logic.ortalama-shade {
  background-color: #64b5f6;
}

.diko-comp-bar-value {
  font-size: 9px;
  font-weight: 800;
  color: #000000;
  margin-left: 4px;
  white-space: nowrap;
}

.diko-comp-x-axis {
  display: flex;
  justify-content: space-between;
  font-size: 8.5px;
  font-weight: 800;
  color: #334155;
  margin-top: 3px;
}

/* Genel Degerlendirme Legend Card */
.diko-genel-degerlendirme-col {
  width: 165px;
  display: flex;
  margin-left: 4px;
}

.diko-gd-card {
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 10px;
  box-sizing: border-box;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}

.diko-gd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1.5px solid #cbd5e1;
  padding-bottom: 2px;
}

.diko-gd-title {
  font-size: 9.5px;
  font-weight: 800;
  color: #000000;
}

.diko-gd-star-circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #10b981;
  display: flex;
  align-items: center;
  justify-content: center;
}

.diko-gd-star {
  color: #ffffff;
}

.diko-gd-text {
  font-size: 8.5px;
  line-height: 1.35;
  color: #0f172a;
  margin: 3px 0;
  font-weight: 600;
}

.diko-gd-legend {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.diko-legend-item {
  display: flex;
  align-items: center;
  font-size: 8px;
}

.diko-legend-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
}

.diko-legend-label {
  font-weight: 800;
  width: 10px;
  color: #000000;
}

.diko-legend-desc {
  color: #334155;
  font-weight: 700;
}

/* 6. CEVAP ANALİZİ VE ORTALAMA KARŞILAŞTIRMASI */
.diko-qa-cols {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.diko-qa-col {
  width: 32.5%;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff;
}

.diko-qa-table-header {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 2px solid var(--diko-qa-color);
}

.diko-qa-table-header.diko-theme-attention {
  --diko-qa-color: #7c3aed;
  --diko-qa-icon-bg: #f5f3ff;
}

.diko-qa-table-header.diko-theme-concentration {
  --diko-qa-color: #0d9488;
  --diko-qa-icon-bg: #f0fdfa;
}

.diko-qa-table-header.diko-theme-logic {
  --diko-qa-color: #2563eb;
  --diko-qa-icon-bg: #eff6ff;
}

.diko-qa-header-title {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 800;
  gap: 8px;
  color: #0f172a;
}

.diko-qa-header-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--diko-qa-icon-bg);
  color: var(--diko-qa-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.diko-qa-table {
  width: 100%;
  border-collapse: collapse;
}

.diko-qa-table th {
  font-size: 8px;
  font-weight: 800;
  color: #334155;
  padding: 2px 6px;
  text-align: left;
  border-bottom: 1.5px solid #cbd5e1;
  background-color: #f8fafc;
}

.diko-qa-table td {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-bottom: 1px solid #e2e8f0;
  color: #000000;
}

.diko-qa-qname {
  color: #334155 !important;
}

.diko-qa-ans {
  display: flex;
  align-items: center;
  gap: 3px;
  font-weight: 800;
}

.diko-qa-ans.correct {
  color: #047857; /* Darker green for B&W print visibility */
}

.diko-qa-ans.incorrect {
  color: #b91c1c; /* Darker red for B&W print visibility */
}

.diko-qa-ans.empty {
  color: #64748b; /* Neutral gray for empty (unanswered) questions */
}

.diko-qa-avg {
  color: #000000 !important;
  font-weight: 800;
}

/* Hafıza block in answers */
.diko-memory-section {
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 8px;
  background-color: #ffffff;
  margin-top: 2px;
}

.diko-memory-header {
  border-bottom: 2px solid #ea580c;
  padding: 0 0 4px;
  margin-bottom: 4px;
  display: flex;
  justify-content: flex-start;
}

.diko-memory-title-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.diko-memory-icon-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff7ed;
  color: #ea580c;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.diko-memory-title {
  font-size: 11px;
  font-weight: 800;
  color: #0f172a;
}

.diko-memory-blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 10px;
}

.diko-memory-block {
  width: calc((100% - 20px) / 3);
  flex: 0 0 calc((100% - 20px) / 3);
  min-width: 0;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  padding: 4px 6px;
  box-sizing: border-box;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.diko-mem-block-title {
  font-size: 10px;
  font-weight: 800;
  color: #000000;
  border-bottom: 1.5px solid #cbd5e1;
  width: 100%;
  text-align: center;
  padding-bottom: 2px;
  margin-bottom: 4px;
}

.diko-mem-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 8px;
  row-gap: 6px;
}

.diko-mem-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 38px;
  flex: 0 0 38px;
}

.diko-mem-circle {
  width: 21px;
  height: 21px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  position: relative;
}

.diko-mem-circle.correct {
  border: 1.5px solid #047857;
  color: #047857;
  background-color: #ecfdf5;
}

.diko-mem-circle.incorrect {
  border: 1.5px solid #b91c1c;
  color: #b91c1c;
  background-color: #fef2f2;
}

.diko-mem-circle.empty {
  border: 1.5px solid #64748b;
  color: #64748b;
  background-color: #f1f5f9;
}

.diko-mem-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  font-size: 7px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid currentColor;
}

.diko-mem-badge.correct {
  background-color: #ffffff;
  color: #047857;
}

.diko-mem-badge.incorrect {
  background-color: #ffffff;
  color: #b91c1c;
}

.diko-mem-badge.empty {
  background-color: #ffffff;
  color: #64748b;
}

.diko-strike {
  text-decoration: line-through;
  opacity: 0.55;
}

.diko-mem-avg {
  font-size: 9px;
  font-weight: 800;
  color: #1e293b;
  line-height: 1;
  white-space: nowrap;
  margin-top: 2px;
}

/* 7. FOOTER SECTION */
.diko-report-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8mm;
  background-color: #0f172a;
  color: #ffffff;
  padding: 0 12px;
  border-radius: 4px;
}

.diko-footer-left {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
  font-weight: 700;
}

.diko-footer-info-icon {
  color: #38bdf8;
}

.diko-footer-right {
  font-size: 9px;
  font-weight: 700;
}
</style>

<style lang="scss">
@media print {
  @page {
    size: A4 portrait;
    margin: 0 !important;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: 296mm !important;
    min-height: 0 !important;
    overflow: hidden !important;
    background-color: #ffffff !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  #app {
    width: 100% !important;
    height: 296mm !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }

  #app > div {
    width: 100% !important;
    height: 296mm !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }

  .diko-report-container-wrapper {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    height: 296mm !important;
    min-height: 0 !important;
    max-height: 296mm !important;
    overflow: hidden !important;
    background: none !important;
    break-inside: avoid-page;
    break-after: avoid-page;
    page-break-inside: avoid;
    page-break-after: avoid;
  }

  .diko-report-container {
    width: 100% !important;
    height: 296mm !important;
    min-height: 0 !important;
    max-height: 296mm !important;
    margin: 0 !important;
    padding: 10mm 12mm !important;
    overflow: hidden !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    border: none !important;
    box-sizing: border-box !important;
    background-color: #ffffff !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
